import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { fAuth } from "../config/firebase";
import { signOut } from "firebase/auth";
import { useAuthContext } from "../hooks/useAuth";

const ConfirmLogout = ({ onClose }) => {
  // const [signOut] = useSignOut(fAuth);
  const { authed, setAuthed } = useAuthContext();
  const navigate = useNavigate();

  const onLogout = async () => {
    try {
      await signOut(fAuth);
      setAuthed(false);
      navigate("/login");
      onClose();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Modal show={true} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>Are you sure you need to logout?</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="danger" onClick={onLogout}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmLogout;
